import type { PlanChange } from './types'

export const formatDateShort = new Intl.DateTimeFormat('en-US', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
})

export const formatDateLong = new Intl.DateTimeFormat('en-US', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
})

export const formatMonth = (d: Date) =>
  d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })

export const formatMonthUrl = (d: Date) => formatMonth(d).replace(' ', '+')

export const formatCCExpires = new Intl.DateTimeFormat('en-US', {
  month: '2-digit',
  year: '2-digit',
})

export const formatPercentage = new Intl.NumberFormat('en-US', {
  style: 'percent',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
})

export const formatGb = new Intl.NumberFormat('en-US', {
  style: 'unit',
  unit: 'gigabyte',
  unitDisplay: 'short',
  minimumFractionDigits: 0,
  maximumFractionDigits: 3,
})

export const getFormatCurrency = (currency = 'USD', options?: Intl.NumberFormatOptions) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    ...(options ?? {}),
  })
}

export const formatPlanChangeType = (type: PlanChange['type']) => {
  switch (type) {
    case 'avoided_credit_card_entering':
      return 'Avoided entering credit card'
    case 'changed_by_admin':
      return 'Changed by admin'
    case 'downgrade':
      return 'Downgrade'
    case 'upgrade':
      return 'Upgrade'
    case 'signup':
      return 'Signup'
    default:
      return type
  }
}
